'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled, { css } from 'styled-components';

var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    height: ", ";\n    display: flex;\n    flex-direction: column;\n"], ["\n    position: relative;\n    height: ", ";\n    display: flex;\n    flex-direction: column;\n"])), function (_a) {
    var height = _a.height;
    return "".concat(height, "px");
});
var SliderContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100%;\n    overflow: hidden;\n    display: flex;\n"], ["\n    width: 100%;\n    overflow: hidden;\n    display: flex;\n"])));
styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    gap: ", "px;\n    height: 100%;\n"], ["\n    display: flex;\n    gap: ", "px;\n    height: 100%;\n"])), function (_a) {
    var spaceElement = _a.spaceElement;
    return spaceElement;
});
styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: inline-block;\n    height: 100%;\n    ", "\n"], ["\n    display: inline-block;\n    height: 100%;\n    ", "\n"])), function (_a) {
    var widthElement = _a.widthElement;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        width: ", "px !important;\n    "], ["\n        width: ", "px !important;\n    "])), widthElement);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

export { Container, SliderContainer };
//# sourceMappingURL=Slider.css.js.map
